<template>
    <div class="theme-ghipss">
        <div class="overlay"></div>
        <top-nav />
        <section>
            <left-nav />
            <right-nav />
        </section>
        <section class="content">
            <div class="container-fluid">
                <div class="block-header">
                    <h2>SPONSORED BANKS</h2>
                </div>
                <div class="row clearfix">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-15" id="bank_table_div">
                        <div class="card">
                            <div class="row header">
                                <div class="pull-left">
                                    <h2 v-show="firstSearch">
                                        <span>Sponsored Banks List</span>
                                    </h2>
                                </div>
                                <div class="pull-right" style="margin:-10px 0px 0px 0px" v-show="firstSearch">
                                    <button type="button" class="btn btn-ghipss btn-circle waves-effect waves-circle waves-float" data-toggle="modal"
                                    data-target="#sponsoredBankModal" data-backdrop="static" @click="openAddModal()">
                                        <i class="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                            <div class="row body">
                                <div class="container-fluid">
                                    <div class="pull-left">
                                        <p>
                                            <!-- Excel export or other actions can go here -->
                                        </p>
                                    </div>
                                    <div class="pull-right">
                                        <div class="form-group" style="margin:-10px 0px 0px 0px">
                                            <div class="form-line">
                                                <input type="text" placeholder="Search here..." v-model="searchInput" class="form-control" @input="searchEvent" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Bank</th>
                                                <th>Limit</th>
                                                <th>Balance</th>
                                                <th>Active</th>
                                                <th>Last Date Modified</th>
                                                <th class="disabled-sorting text-right">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="filteredEntries.length > 0">
                                            <tr v-for="(bank, i) in filteredEntries" :key="i">
                                                <td>{{ getBankNameByCode(bank.bankCode) }}</td>
                                                <td>{{ bank.limit }}</td>
                                                <td>{{ bank.balance }}</td>
                                                <td>
                                                    <span v-if="bank.active" class="label bg-green">Active</span>
                                                    <span v-else class="label bg-red">Inactive</span>
                                                </td>
                                                <td>{{ getFormattedDate(bank.lastModified) }}</td>
                                                <td class="text-right">
                                                    <a href="#" @click="openEditModal(bank)" class="btn btn-warning btn-circle waves-effect waves-circle waves-float" data-toggle="modal" data-target="#sponsoredBankModal" data-backdrop="static">
                                                        <i class="material-icons">edit</i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="6" class="text-center">No records</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="row">
                                        <div class="col-md-6 col-sm-6 col-xs-6" style="padding: 10px 20px">
                                            <span class="pagination">
                                                showing {{ showInfo.from }} to {{ showInfo.to }} of {{ showInfo.of }} entries
                                            </span>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-xs-6">
                                            <ul class="pagination pull-right">
                                                <li :class="['page-item', {'disabled': currentPage === 1}]">
                                                    <a href="#" class="page-link" @click.prevent="currentPage = 1; paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>
                                                <li :class="['page-item', {'disabled': currentPage === 1}]">
                                                    <a class="page-link" href="#" aria-label="Previous" @click.prevent="currentPage < 1 ? currentPage = 1 : currentPage -= 1; paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>
                                                <li v-for="pagi in showPagination" :key="pagi" :class="['page-item', {'disabled': pagi === '...', 'active': pagi === currentPage}]">
                                                    <a href="#" class="page-link" @click.prevent="paginateEvent(pagi)">{{ pagi }}</a>
                                                </li>
                                                <li :class="['page-item', {'disabled': currentPage === allPages}]">
                                                    <a class="page-link" href="#" aria-label="Next" @click.prevent="currentPage > allPages ? currentPage = allPages : currentPage += 1; paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>
                                                <li :class="['page-item', {'disabled': currentPage === allPages}]">
                                                    <a href="#" class="page-link" @click.prevent="currentPage = allPages; paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Modal for Add/Edit Sponsored Bank -->
        <div class="modal fade" id="sponsoredBankModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="modal-title">
                            {{ modalEditMode ? 'Edit Sponsored Bank' : 'Add Sponsored Bank' }}
                        </h2>
                    </div>
                    <div class="modal-body">
                        <form>
                            <label for="bankCode">Bank</label>
                            <div class="form-group">
                                <template v-if="!modalEditMode">
                                    <select v-model="modalBank.bankCode" class="form-control">
                                        <option value="" disabled>Select a bank</option>
                                        <option v-for="code in sponsoredBankCodes" :key="code" :value="code">
                                            {{ getBankNameByCode(code) }}
                                        </option>
                                    </select>
                                    <span v-if="modalValidation.bankCode" class="text-danger">
                                        {{ modalValidation.bankCode }}
                                    </span>
                                </template>
                                <template v-else>
                                    <div class="form-control" style="background:#f5f5f5; cursor:not-allowed;">
                                        {{ getBankNameByCode(modalBank.bankCode) }} 
                                    </div>
                                </template>
                            </div>
                            <label for="dailyLimit">Daily Limit</label>
                            <div class="form-group">
                                <div class="form-line">
                                    <input type="number" v-model="modalBank.dailyLimit" class="form-control" placeholder="Enter Daily Limit" />
                                </div>
                                <span v-if="modalValidation.dailyLimit" class="text-danger">
                                    {{ modalValidation.dailyLimit }}
                                </span>
                            </div>
                            <label for="active">Active</label>
                            <div class="form-group">
                                <div class="demo-radio-button">
                                    <input type="radio" id="activeYes" value="Y" v-model="modalBank.otpManagement">
                                    <label for="activeYes">Active</label>
                                    <input type="radio" id="activeNo" value="0" v-model="modalBank.otpManagement">
                                    <label for="activeNo">Inactive</label>
                                </div>
                                <span v-if="modalValidation.otpManagement" class="text-danger">
                                    {{ modalValidation.otpManagement }}
                                </span>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success waves-effect" @click.prevent="submitSponsoredBankForm">Save</button>
                        <button type="button" class="btn btn-danger waves-effect" @click="closeModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
import TopNav from "@/components/TopNav.vue";
import LeftNav from "@/components/LeftNav.vue";
import RightNav from "@/components/RightNav.vue";
import moment from "moment";
import { $array } from 'alga-js';
import axios from '@/axios.js';

export default {
    name: 'SponsoredBanks',
    components: {
        TopNav,
        LeftNav,
        RightNav
    },
    data() {
        return {
            allBanks: [],
            isLoading: false,
            error: '',
            isDownloading: false,
            firstSearch: true,
            lastUpdateTime: '',
            entries: [],
            showEntries: [5, 10, 15, 25, 50, 75, 100],
            currentEntries: 10,
            filteredEntries: [],
            currentPage: 1,
            allPages: 1,
            searchInput: '',
            searchEntries: [],
            modalEditMode: false,
            modalBank: {
                bankCode: '',
                dailyLimit: '',
                otpManagement: 'Y',
            },
            modalValidation: {
                bankCode: '',
                dailyLimit: '',
                otpManagement: '',
            },
            allBanksDropdown: [],
            sponsoredBankCodes: [],
        }
    },
    methods: {
        async fetchSponsoredBanks() {
            this.isLoading = true;
            this.error = '';
            try {
                const fiCode = localStorage.getItem('bankcode');
                const response = await axios.get(`sponsored_bank/get_sponsored_bank/${fiCode}`);
                //const response = await axios.get(`sponsored_bank/get_sponsored_bank/300325`);
                // Map API fields to table fields
                this.allBanks = (response.data || []).map(item => ({
                    bankCode: item.bankCode || item.bank_code || item.fiCode, // always store the code for API
                    limit: item.dailyLimit,
                    balance: item.balance, // assuming 'balance' is already correct
                    active: item.otpManagement === 'Y',
                    lastModified: item.dateModif
                }));
                this.paginateEntries();
            } catch (err) {
                this.error = 'Failed to load sponsored banks.';
                this.allBanks = [];
                this.filteredEntries = [];
            } finally {
                this.isLoading = false;
            }
        },
        async fetchAllBanksDropdown() {
            try {
                const response = await axios.get('bank/get_banks');
                this.allBanksDropdown = response.data;
            } catch (err) {
                this.allBanksDropdown = [];
            }
        },
        async fetchSponsoredBankCodes() {
            try {
                const fiCode = localStorage.getItem('bankcode');
                const response = await axios.get(`sponsored_bank/get_sponsored_bank_list/${fiCode}`);
                //const response = await axios.get(`sponsored_bank/get_sponsored_bank_list/300325`);
                if (response.status == 200) {
                    this.sponsoredBankCodes = response.data || [];
                }else{
                    his.$swal('Failed', 'Error loading records!', 'error')                

                }
            } catch (err) {
                this.sponsoredBankCodes = [];
            }
        },
        paginateEntries() {
            if (this.searchInput.length >= 1) {
                this.searchEntries = $array.search(this.searchInput)(this.allBanks)
                this.filteredEntries = $array.paginate(this.searchEntries)(this.currentPage, this.currentEntries)
                this.allPages = $array.pages(this.searchEntries, this.currentEntries)
            } else {
                this.searchEntries = []
                this.filteredEntries = $array.paginate(this.allBanks)(this.currentPage, this.currentEntries)
                this.allPages = $array.pages(this.allBanks, this.currentEntries)
            }
        },
        paginateEvent(page) {
            this.currentPage = page;
            this.paginateEntries();
        },
        searchEvent() {
            this.currentPage = 1
            this.paginateEntries()
        },
        getFormattedDate(date) {
            return moment(date).format("YYYY-MM-DD  hh:mm a");
        },
        openAddModal() {
            this.modalEditMode = false;
            this.modalBank = {
                bankCode: '',
                dailyLimit: '',
                otpManagement: 'Y',
            };
            this.modalValidation = {
                bankCode: '',
                dailyLimit: '',
                otpManagement: '',
            };
            this.fetchSponsoredBankCodes();
        },
        openEditModal(bank) {
            this.modalEditMode = true;
            this.modalBank = {
                bankCode: bank.bankCode,
                dailyLimit: bank.limit,
                otpManagement: bank.active ? 'Y' : '0',
            };
            this.modalValidation = {
                bankCode: '',
                dailyLimit: '',
                otpManagement: '',
            };
        },
        closeModal() {
            $('#sponsoredBankModal').modal('hide');
        },
        validateModalForm() {
            let valid = true;
            this.modalValidation = {
                bankCode: '',
                dailyLimit: '',
                otpManagement: '',
            };
            if (!this.modalBank.bankCode) {
                this.modalValidation.bankCode = 'Please select a bank.';
                valid = false;
            }
            if (!this.modalBank.dailyLimit || isNaN(this.modalBank.dailyLimit) || Number(this.modalBank.dailyLimit) <= 0) {
                this.modalValidation.dailyLimit = 'Daily Limit must be a positive number.';
                valid = false;
            }
            if (!this.modalBank.otpManagement) {
                this.modalValidation.otpManagement = 'Please select Active or Inactive.';
                valid = false;
            }
            return valid;
        },
        async submitSponsoredBankForm() {
            if (!this.validateModalForm()) return;
            // Prepare payload for API
            const payload = {
                bankCode: this.modalBank.bankCode,
                dailyLimit: this.modalBank.dailyLimit,
                otpManagement: this.modalBank.otpManagement,
                createdBy: localStorage.getItem('email'),
            };
            console.log('Prepared payload for API:', payload);

            try {
                if (!this.modalEditMode) {
                    // Add new sponsored bank
                    const response = await axios.post('sponsored_bank/add_limit', payload);
                    if (response.status == 200) {
                        console.log('Response data:', response.data);
                        if(response.data.errorCode == '0'){
                            this.$swal('Success', 'Sponsored bank added successfully!', 'success')
                            this.fetchSponsoredBanks();
                            this.closeModal();
                        } else {
                            this.$swal('Failed', response.data.errorMessage, 'error')
                        }
                    } else {
                        this.$swal('Failed', 'Error adding sponsored bank!', 'error')
                    }
                } else {
                    // Update existing sponsored bank
                    const response = await axios.post('sponsored_bank/update_limit', payload);
                    if (response.status == 200) {
                        console.log('Response data:', response.data);
                        if(response.data.errorCode == '0'){
                            this.$swal('Success', 'Sponsored bank updated successfully!', 'success')
                            this.fetchSponsoredBanks();
                            this.closeModal();
                        } else {
                            this.$swal('Failed', response.data.errorMessage, 'error')
                        }
                    } else {
                        this.$swal('Failed', 'Error updating sponsored bank!', 'error')
                    }
                }
            } catch (err) {
                console.error('Error saving sponsored bank:', err);
                // TODO: Show error message to user
            }
            this.closeModal();
            // Optionally, refresh the table data
            this.fetchSponsoredBanks();
        },
        getBankNameByCode(code) {
            const bank = this.allBanksDropdown.find(b => b.fiCode === code || b.bankCode === code);
            return bank ? bank.bankName : code;
        },
    },
    mounted() {
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', '/js/admin.js')
        document.body.appendChild(externalScript)
        this.moment = moment;

        this.fetchSponsoredBanks();
        this.fetchAllBanksDropdown();
        this.fetchSponsoredBankCodes();
    },
    computed: {
        showInfo() {
            const getCurrentEntries = this.searchEntries.length <= 0 ? this.allBanks : this.searchEntries
            return $array.show(getCurrentEntries)(this.currentPage, this.currentEntries)
        },
        showPagination() {
            return $array.pagination(this.allPages, this.currentPage, 1)
        }
    },
}
</script> 